module.exports = __webpack_public_path__ + "img/rep-julia.50e74c9f.jpg";